'use strict';

var React = require('react');
var MenuItem = require('../../DesignSystem/Navigation/Menus/MenuItem.js');
var PropTypes = require('prop-types');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

var KanbanMenuItems = function KanbanMenuItems(props) {
  return React__default["default"].createElement(React__default["default"].Fragment, null, props.children.map(function (node) {
    return React__default["default"].createElement(MenuItem, {
      onClick: function onClick() {
        props.close();
        typeof node.props.onClick === 'function' && node.props.onClick();
      }
    }, node.props.title || '');
  }));
};

KanbanMenuItems.defaultProps = {
  children: PropTypes__default["default"].arrayOf(PropTypes__default["default"].node),
  close: PropTypes__default["default"].func
};

module.exports = KanbanMenuItems;
